import { LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";
import { signInAgain } from "../lib/auth-redirect";

/**
 * Expliziter Abgemeldet-Zustand nach bewusstem Logout (#95). Verhindert die
 * stille Re-Authentifizierung: statt 401 -> Auto-Redirect auf /auth/login bleibt
 * der User sichtbar abgemeldet und meldet sich nur auf Klick erneut an.
 */
export function SignedOut(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="signed-out">
      <div className="signed-out__card">
        <h2 className="signed-out__title">{t("auth.signedOutTitle")}</h2>
        <p className="signed-out__hint">{t("auth.signedOutHint")}</p>
        <button type="button" className="nav-btn nav-btn--cta" onClick={() => signInAgain()}>
          <LogIn size={15} strokeWidth={2.5} aria-hidden="true" />
          {t("auth.signInAgain")}
        </button>
      </div>
    </div>
  );
}
